import { Trans } from '@lingui/react/macro';

import { ToothIcon } from '../../../svgs/toothIcon';
import type {
  MouthArea,
  VisitTreatmentWithCount,
} from '../patientStrip/patientStripOdontogram/hooks';

export const TreatmentsCellTreatment = ({
  affectedArea,
  treatments,
}: {
  affectedArea: MouthArea;
  treatments?: VisitTreatmentWithCount[];
}) => {
  return (
    <div className="vai-flex vai-flex-row vai-items-start vai-gap-4 vai-w-full">
      <span className="vai-flex vai-items-center vai-gap-2 vai-text-normal">
        <ToothIcon />
        <p className="vai-typography-p !vai-leading-5">{affectedArea}</p>
      </span>

      <div className="vai-flex vai-flex-col vai-gap-1">
        {treatments?.map(({ count, txGroupLongName, txCode }) => (
          <span
            className="vai-flex vai-items-center vai-typography-small !vai-font-normal"
            key={`${txGroupLongName.en}-${txCode}`}
          >
            <Trans>{`${txGroupLongName.en} [${txCode}]`}</Trans>{' '}
            {count && count > 1 && `(${count})`}
          </span>
        ))}
      </div>
    </div>
  );
};
